import { Tag } from 'antd'

export const labelOptions = [
  {
    value: '2',
    label: 'Bán'
  },
  {
    value: '1',
    label: 'Thuê'
  }
]

export const ACTION_MODE = {
  VIEW: 'VIEW',
  ADD: 'ADD',
  UPDATE: 'UPDATE'
}

export const titleMap = {
  '/': 'Trang Chủ',
  // '/': 'Đăng nhập',
  '/terms-of-service': 'Điều khoản dịch vụ',
  '/information-security-policy': 'Chính sách bảo mật thông tin',
  '/terms-of-agreement': 'Điều khoản thoả thuận',
  '/complaint-resolution': 'Giải quyết khiếu nại',
  '/operating-regulations': 'Quy chế hoạt động',
  '/general-provisions': 'Quy định chung',
  '/system-manager': 'Quản lý vận hành hệ thống',
  '/role-management': 'Quản lý Quyền',
  '/user-management': 'Quản lý Tài khoản',
  '/department-management': 'Quản lý sàn',
  '/post-management': 'Quản lý tin BĐS nội bộ',
  '/duplicate-post-management': 'Quản lý trùng tin BĐS nội bộ',
  '/duplicate-post-community-management': 'Quản lý trùng tin Cộng đồng',
  '/request-internal-management': 'Quản lý yêu cầu nội bộ',
  '/post-community-management': 'Quản lý tin Cộng đồng',
  '/project-management': 'Quản lý Thư viện dự án',
  '/project-recommend-management': 'Quản lý Dự án mở bán',
  '/project-recommend-register':
    'QL người dùng ĐK tư vấn thông tin dự án và ĐK xem căn hộ mẫu',
  '/notification-management': 'Quản lý thông báo',
  '/community-pakage': 'QL cấu hình gói gia hạn cộng đồng',
  '/community-pakage-history': 'QL lịch sử gia hạn cộng đồng',
  '/configuration-pakage-post': 'Quản lý cấu hình gói tin đăng Web',
  '/history-pakage-post': 'Quản lý lịch sử gói tin đăng Web',
  '/manager-post-web': 'Quản lý tin đăng trên Web',
  '/manager-request-post-web': 'Quản lý yêu cầu trên Web',
  '/manager-payment-gateway': 'Quản lý đối soát qua Cổng thanh toán',
  '/manager-footer': 'Quản lý footer',
  '/manager-imess': 'Quản lý số iMess',
  '/recharge-packages-promotions': 'Quản lý gói nạp tiền & khuyến mãi',
  '/recharge-packages-promotions-history': 'QL nạp tiền & thanh toán',
  '/manager-slide': 'Quản lý Side ảnh và banner',
  '/auction-and-view-history': 'QL người dùng đấu giá và đăng ký xem nhà',
  '/center-info': 'Quản lý thông tin trung tâm',
  '/web-fee-management': 'Quản lý thu phí Web',
  '/service-management': 'Quản lý dịch vụ',
  '/management-recruitment': 'Quản lý tuyển dụng',
  '/breaking-news': 'Quản lý tin nhanh',
  '/selection-management': 'Quản lý selection',
  '/data-customer-management': 'DATA dữ liệu khách hàng',
  '/account-web-management': 'Quản lý tài khoản web',
  '/management-booking': 'Quản lý booking'
}

export const PAGE_SIZE_OPTIONS = ['10', '20', '50', '100']

export const UTILITY_OPTIONS = [
  {
    label: 'Bể bơi',
    value: 'swimmingpool'
  },
  {
    label: 'Nhà hàng',
    value: 'restaurant'
  },
  {
    label: 'Thang máy',
    value: 'elevator'
  },
  {
    label: 'Siêu thị',
    value: 'supermarket'
  },
  {
    label: 'Nhà trẻ',
    value: 'kindergarden'
  },
  {
    label: 'Camera',
    value: 'camera'
  },
  {
    label: 'Báo cháy',
    value: 'fire'
  },
  {
    label: 'Công viên',
    value: 'part'
  },
  {
    label: 'Cafe',
    value: 'cafe'
  },
  {
    label: 'Bảo vệ',
    value: 'security'
  }
]

export const OPTIONS_ROLE = [
  {
    value: 'CEO',
    name: 'CEO'
  },
  {
    value: 'DIRECTOR',
    name: 'Giám đốc'
  },
  {
    value: 'SALE_MANAGER',
    name: 'Quản lý sản phẩm'
  },
  {
    value: 'SALE',
    name: 'Nhân viên'
  },
  {
    value: 'CUSTOMER',
    name: 'Khách hàng'
  }
]

export const OPTIONS_TYPE_REQUEST = [
  {
    value: 1,
    name: 'Xem căn hộ mẫu'
  },
  {
    value: 2,
    name: 'Đăng ký nhận thông tin dự án'
  }
]
export const OPTIONS_STATUS_NOTIFICATION = [
  {
    value: 0,
    name: 'Chưa gửi'
  },
  {
    value: 1,
    name: 'Đã gửi'
  },
  {
    value: 2,
    name: 'Hủy'
  }
]
export const OPTIONS_STATUS_PACKAGE = [
  {
    value: 0,
    name: 'Chưa gửi'
  },
  {
    value: 1,
    name: 'Đã gửi'
  },
  {
    value: 2,
    name: 'Hủy'
  }
]

export const TIME_PACKAGE_DAYS = {
  1: 1,
  3: 3,
  6: 6,
  9: 9,
  12: 12
}
export const TIME_PAKAGE = [
  {
    value: 1,
    name: '1 tháng'
  },
  {
    value: 3,
    name: '3 tháng'
  },
  {
    value: 6,
    name: '6 tháng'
  },
  {
    value: 9,
    name: '9 tháng'
  },
  {
    value: 12,
    name: '12 tháng'
  }
]

export const OPTIONS_PACKAGE_TYPE = [
  {
    value: 1,
    name: 'Mua gói tin'
  },
  {
    value: 2,
    name: 'Cộng điểm'
  }
]
export const OPTIONS_PACKAGE_STATUS = [
  {
    value: 1,
    name: 'Đang xử lý',
    color: 'yellow'
  },
  {
    value: 2,
    name: 'Thành công',
    color: 'green'
  },
  {
    value: 3,
    name: 'Thất bại',
    color: 'red'
  }
]
export const OPTIONS_PACKAGE_POST = [
  {
    value: 1,
    name: 'Hiệu lực'
  },
  {
    value: 2,
    name: 'Hết hiệu lực'
  }
]
export const OPTIONS_OBJECT_POST = [
  {
    value: 'INDIVIDUAL',
    name: 'Cá nhân'
  },
  {
    value: 'BUSINESS',
    name: 'Doanh nghiệp'
  }
]

export const OPTIONS_LABEL_POST_WEB = [
  {
    value: 1,
    name: 'Thuê'
  },
  {
    value: 2,
    name: 'Mua'
  }
]

export const OPTIONS_DEPOSIT = [
  {
    value: 1,
    name: 'CMS'
  },
  {
    value: 2,
    name: 'VNPAY'
  }
  // {
  //   value: 3,
  //   name: 'Thêm thủ công'
  // }
]
export const OPTIONS_STATUS_POST_WEB = [
  {
    value: 'INDIVIDUAL',
    name: 'Đã thanh toán'
  },
  {
    value: 'BUSINESS',
    name: 'Hoạt động'
  },
  {
    value: 'BUSINESS',
    name: 'Hủy bỏ'
  }
]

export const TagCustom = ({ arr, status }) => {
  const item = arr.find((item) => item.value === status) || {
    color: 'default',
    name: 'Không xác định'
  }

  return <Tag color={item.color}>{item?.name}</Tag>
}

export const OPTIONS_LABEL_DASHBOARD = [
  {
    value: 2,
    name: 'Bán'
  },
  {
    value: 1,
    name: 'Thuê'
  }
]

export const realEstateOptions = [
  {
    label: 'Căn hộ',
    value: 'APARTMENT',
    children: [
      { value: 1, label: 'Căn hộ chung cư' },
      { value: 2, label: 'Căn hộ Penthouse' },
      { value: 3, label: 'Căn hộ Duplex' },
      { value: 4, label: 'Căn hộ Studio' },
      { value: 5, label: 'Căn hộ Officetel' },
      { value: 6, label: 'Căn hộ Dual Key' },
      { value: 7, label: 'Căn hộ Sân Vườn' },
      { value: 8, label: 'Căn hộ khác' }
    ]
  },
  {
    label: 'Tòa nhà',
    value: 'BUILDING',
    children: [
      { value: 30, label: 'Sàn văn phòng' },
      { value: 31, label: 'Sàn thương mại' },
      { value: 32, label: 'Toà văn phòng' },
      { value: 33, label: 'Toà khách sạn' },
      { value: 34, label: 'Toà nhà hỗn hợp' },
      { value: 35, label: 'Toà nhà khác' }
    ]
  },
  {
    label: 'Nhà đất',
    value: 'REAL_ESTATE',
    children: [
      { value: 40, label: 'Nhà ngõ' },
      { value: 41, label: 'Nhà mặt phố' },
      { value: 42, label: 'Biệt thự' },
      { value: 43, label: 'Liền kề' },
      { value: 44, label: 'Shophouse' },
      { value: 45, label: 'Nhà đất khác' }
    ]
  },
  {
    label: 'Đất nền',
    value: 'GROUND',
    children: [
      { value: 20, label: 'Đất ở' },
      { value: 26, label: 'Đất dự án' },
      { value: 21, label: 'Đất khu công nghiệp' },
      { value: 22, label: 'Nhà xưởng' },
      { value: 23, label: 'Kho/Bãi' },
      { value: 24, label: 'Đất kinh doanh dịch vụ' },
      { value: 25, label: 'Đất nền khác' }
    ]
  }
]

export const OPTIONS_CODE = [
  {
    value: 'INTRODUCE',
    name: 'Giới thiệu'
  },
  {
    value: 'TERM',
    name: 'Điều khoản sử dụng'
  },
  {
    value: 'POLICY',
    name: 'Chính sách'
  },
  {
    value: 'REGULATION',
    name: 'Quy định chung'
  },
  {
    value: 'PHONE',
    name: 'Hỗ trợ - Call/Zalo/SMS {Trang cá nhân nội bộ}'
  },
  {
    value: 'PHONE_COMMUNITY',
    name: 'Hỗ trợ - Call/Zalo/SMS {Trang cá nhân cộng đồng}'
  },
  {
    value: 'PHONE_COMMUNITY_SUPPORT',
    name: 'Hỗ trợ - Call/Zalo/SMS {Hỗ trợ cộng đồng}'
  },
  {
    value: 'GUIDE',
    name: 'Hướng dẫn sử dụng - Cộng đồng'
  },
  {
    value: 'CALLCENTER',
    name: 'Liên hệ chăm sóc khách hàng'
  },
  {
    value: 'CONTRACT',
    name: 'Mẫu hợp đồng'
  },
  {
    value: 'ACCOUNT',
    name: 'Tài khoản ngân hàng'
  },
  {
    value: 'DEPARTMENT',
    name: 'Cấu hình sàn tài khoản khách hàng trên cộng đồng'
  },
  {
    value: 'PAYMENT_SUPPORT',
    name: 'Liên hệ hỗ trợ thanh toán để hỗ trợ nạp tiền trên App'
  },
  {
    value: 'SHOW_PAYMENT',
    name: 'Hiển thị cổng thanh toán'
  },
  {
    value: 'USER_ACCESS',
    name: 'Quản lý User truy cập'
  },
  {
    value: 'CHOOSE_NETWORK',
    name: 'Quản lý mạng truy cập'
  },
  {
    value: 'CONFIG_FLOOR',
    name: 'Tính khoảng tầng'
  }
]

export const fieldLabels = {
  manager_post_id: 'Quản lý tin',
  label: 'Nhu cầu đăng tin',
  post_type: 'Loại BĐS',
  type_real_estate: 'Loại hình BĐS',
  project_id: 'Tên dự án',
  city_code: 'Tỉnh/Thành phố',
  district_code: 'Quận/Huyện',
  town_code: 'Phường/Xã',
  street: 'Đường phố',
  apartment_code: 'Mã căn hộ',
  building: 'Tòa khu',
  floor: 'Tầng/Dãy',
  number_of_rooms: 'Số căn',
  alley: 'Số địa chỉ',
  acreage: 'Diện tích (m)',
  area_outside: 'Mặt tiền (m)',
  number_of_floor: 'Số tầng',
  number_of_bedrooms: 'Số phòng ngủ',
  number_of_wc: 'Số WC',
  direction: 'Hướng',
  apartment_location: 'Vị trí',
  legal: 'Giấy tờ pháp lý',
  price: 'Giá',
  cost: 'Phí môi giới',
  procedure: 'Phí giao dịch',
  furniture: 'Nội thất',
  status: 'Hiện trạng',
  processing_status: 'Trạng thái tin',
  security: 'Bảo mật thông tin',
  customer_phone_number: 'Số điện thoại liên hệ',
  content: 'Mô tả',
  title: 'Tiêu đề',
  department_id: 'Sàn',
  updated_at: 'Thời gian cập nhật',
  customer_name: 'Tên chủ nhà',
  customer_email: 'Email chủ nhà',
  description: 'Mô tả',
  post_status: 'Trạng thái tin',
  created_at: 'Ngày tạo',
  request_type: 'Nhu cầu',
  customer_full_name: 'Họ và tên khách hàng',
  identifier_type: 'Định danh'
}

export const TMCE_KEY = 't329weoxjnbj344e6paszjetgszhnqdpa3ewfek5egyyhz9j'

export const OPTIONS_PAYMENT_METHOD = [
  {
    value: 1,
    name: 'CMS'
  },
  {
    value: 2,
    name: 'VNPay'
  }
]

export const OPTIONS_STATUS_SELECTION = [
  {
    value: 1,
    name: 'ACTIVE'
  },
  {
    value: 2,
    name: 'INACTIVE'
  }
]

export const OPTIONS_RECRUITMENT = [
  {
    value: '0',
    name: 'Chưa xử lý'
  },
  {
    value: '1',
    name: 'Đã xử lý'
  }
]
